export function generateJsClient(userServer) {
    const trueScript = btoa(`document.write(\`<script async src="${userServer}?referrerCF=\${escape(document.referrer)}&urlCF=\${escape(window.location.href)}"><\\/script>\`)`)
    return `<script src="data:text/javascript;base64,${trueScript}"></script>`
}

export function generateJsClientSimple(userServer) {
    const wrapper = `<script async>document.write(\`<script async src="${userServer}?referrerCF=\${escape(document.referrer)}&urlCF=\${escape(window.location.href)}"><\\/script>\`)</script>`
    return wrapper
}